import { z } from 'zod';

/** A person's or family's display name. Trimmed, non-empty, bounded. */
export const personNameSchema = z.string().trim().min(1).max(80);

export type PersonName = z.infer<typeof personNameSchema>;

/** Short free text on an activity: formula name, food, location, reaction. */
export const activityLabelSchema = z.string().trim().min(1).max(200);

/** Optional note. Empty strings are stored as null. */
export const activityNoteSchema = z
    .string()
    .trim()
    .max(2000)
    .transform((value) => (value.length === 0 ? null : value));
